export default __webpack_public_path__ + "static/media/1827.9662476a.png";